import styled, { css } from 'styled-components';

interface ItemProps {
  readonly theme?: string;
  readonly checked?: boolean;
  readonly first?: boolean;
  readonly posX?: number;
  readonly posY?: number;
  readonly topPosition?: string;
  readonly topPositionResponsive?: string;
  readonly minWidth?: string;
  readonly type?: string;
  readonly backgroundColor?: string;
  readonly boxShadow?: string;
  readonly leftFeatureLocked?: string;
  readonly rightFeatureLocked?: string;
  readonly alertTextColor?: string;
}

interface FeatureLocked {
  readonly left: number;
  readonly right: number;
}

export const SortPopUp = styled.div<ItemProps>`
  width: 160px;
  position: absolute;
  z-index: 4;
  top: ${props => (props.posY ? `${props.posY}px` : '30px')};
  left: ${props => (props.posX ? `${props.posX}px` : '-50px')};

  box-sizing: border-box;

  border: 1.5px solid rgba(255, 255, 255, 1);
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 5px 11px 0 rgba(0, 0, 0, 0.09);
  span {
    font-weight: 400 !important;
  }
`;
export const ArrowUp = styled.div`
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent rgba(255, 255, 255, 1) transparent;
  top: -20px;
  left: 70px;
`;
export const RadiosContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding-left: 6px;
  padding-top: 12px;
  padding-bottom: 5px;
  z-index: 1 !important;
`;
export const ShadowSummaryColumn = styled.td`
  background: #ebedf2 !important;
`;
export const ShadowTableColumn = styled.td`
  background: #f7f8fa !important;
`;

export const DailyLogWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-direction: row;
  color: rgba(93, 110, 129, 1);
  font-weight: 600;
  font-family: 'Proxima Nova';
  cursor: pointer;
`;
export const TableDefault = styled.table<ItemProps>`
  border-collapse: separate;
  height:fit-content;
  border-spacing: 0;
  margin-bottom: 40px;
  width: 100%;
  max-width: 100%;
  min-width: ${props => props.minWidth && `${props.minWidth}`};

  thead {
    tr {
      th {
        box-shadow: ${props => (props.boxShadow ? props.boxShadow : 'inset 0px -1px #e8e9ed')};
        background-color: #ebedf2;
        color: var(--DarkGray);
        font-size: 12px;
        text-align: center;
        min-width: 45px;

        span {
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          font-weight: 300;
        }
      }
      th.table-first-visible {
        border-bottom: 1px solid #e7e9ec !important;
        background-color: #e7e9ec !important;
        border-top-left-radius: 8px !important;
      }
      .table-left {
        text-align: left !important;
        padding-left: 12px !important;
      }
      .m-width-s {
        min-width: 120px;
      }
      .margin-x-s {
        margin: 0 10px;
      }
      .th-center-y {
        display: flex;
        height: 100%;
        align-items: center;
      }
      &:first-child {
        th {
          min-width: 65px;
          border-bottom: 1px solid #fff;
          border-right: 1px solid #fff;
          font-weight: bold;
          padding: 7px 5px;
          text-transform: uppercase;

          &:last-child {
            border-right: 0;
            border-radius: 0 8px 0 0;
          }
        }
      }
      &:nth-child(1) {
        th {
          background-color: #ebedf2;
          border-right: 1px solid #e8e9ed;
          font-size: 12px;
          font-weight: 600;
          font-family: 'Proxima Nova';
          line-height: 25px;
          padding: 8px 2.5px;

          &:first-child {
            border-radius: 8px 0 0 0;
          }
          &:last-child {
            border-right: 0;
          }
        }
      }
      &:nth-child(2) {
        th {
          text-align: center;
          background-color: #fff;
          border-right: 1px solid #e8e9ed;
          font-weight: normal;
          font-size: 12px;
          color: #5d6e81;
          line-height: 11px;
          padding: 5px 2.5px 5px 2.5px;
          &:first-child {
            border-left: 1px solid #e8e9ed;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        border-bottom: 1px solid #e8e9ed;
        border-right: 1px solid #e8e9ed;
        color: var(--DarkGray);
        height: 34px;
        font-size: 12px;
        text-align: center;
        vertical-align: center;

        &:first-child {
          border-left: 1px solid #e8e9ed;
          padding: 5px 5px 5px 12px;
        }
        b {
          font-weight: 500;
        }
      }
      td.white {
        background-color: #fff !important;
      }
      td.pointer {
        cursor: pointer !important;
      }
      td.table-left {
        text-align: left !important;
        padding: 0 12px !important;
      }
      .radio-container {
        display: flex;
        min-width: 240px;
      }
      .m-width-m {
        min-width: 150px;
      }
      .td-center-y {
        display: flex;
        height: 100%;
        align-items: center;
      }
      .max-width {
        width: max-content;
      }
      &.tr-average {
        td {
          background-color: #f2f8ff;
          &:first-child {
            font-size: 16px;
            padding: 0;
          }
        }
      }
    }
    &.table-player-exam {
      tr {
        td {
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3) {
            background-color: #f9fafb;
          }
        }
      }
    }

    .special-sponsor-item {
      display: flex;
      justify-content: center;
      margin: 0 10px;

      & > div:last-of-type {
        margin-left: 10px;
      }

      & > a {
        margin-left: 10px;
      }
    }
  }
`;

export const TableBasic = styled.table<ItemProps>`
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 40px;
  width: 100%;
  min-width: ${props => props.minWidth && `${props.minWidth}`};
  thead {
    tr {
      th.head-m {
        font-size: 20px;
        font-weight: 600;
      }
      th.transparent {
        background: transparent;
      }
      th.header-centered {
        text-align: center;
      }
      th.left-radio {
        border-top-left-radius: 8px !important;
      }

      th {
        background-color: #ebedf2;
        border-right: 1px solid #e8e9ed;
        color: var(--DarkGray);
        font-size: 12px;
        font-weight: 500;
        line-height: 25px;
        text-align: left;
        padding: 8px 15px;
        white-space: nowrap;
        &:first-child {
          border-radius: 8px 0 0 0;
        }
        &:last-child {
          border-radius: 0 8px 0 0;
          border-right: 0;
        }
        span {
          cursor: pointer;
        }
      }
    }
    tr.font-medium {
      th {
        font-size: 10px;
      }
    }
    tr.blank {
      th {
        background-color: #fff;
      }
    }
  }
  tbody {
    tr {
      &:last-child {
        td {
          &:first-child {
            border-radius: 0 0px 0 8px;
          }
          &:last-child {
            border-radius: 0 0px 8px 0;
          }
        }
      }
      td.head-lite {
        color: #5d6e81;
        font-size: 15px;
        font-weight: 400;
      }
      td.white {
        background-color: #fff !important;
      }
      td {
        background-color: #fff;
        border-bottom: 1px solid #e8e9ed;
        border-right: 1px solid #e8e9ed;
        color: var(--DarkGray);
        height: 58px;
        font-size: 14px;
        font-weight: 500;
        padding: 0 15px;
        text-align: left;
        vertical-align: middle;
        &:first-child {
          border-left: 1px solid #e8e9ed;
          padding: 0px 10px 0px 15px;
        }
        &:last-child {
          background-color: var(--BackgroundLighter);
        }
      }
      &.tr-average {
        td {
          background-color: #f2f8ff;
          &:first-child {
            background-color: #e6f1ff;
            padding: 0;
          }
        }
      }
      &.special-edit-active {
        td {
          background-color: #f2f8ff !important;
        }
      }
    }
    tr.azul {
      td {
        background-color: #f2f8ff;
      }
      td:first-of-type {
        background-color: #e5f1ff;
      }
    }

    &.table-player-billing {
      tr {
        td {
          border-right: none;
          background-color: var(--BackgroundColor);
          &:nth-child(1) {
            font-size: 18px;
            font-weight: 400;
          }
          &:nth-child(2),
          &:nth-child(3) {
            font-weight: 600;
            font-size: 18px;
            text-align: center;
          }
          &:nth-child(3) {
            border-right: 1px solid #e8e9ed;
          }
        }
      }
      tr:last-of-type {
        td:nth-child(2) {
          font-weight: 400;
        }
      }
    }
  }
  .td-center-y {
    justify-content: center;
    align-items: center;
    display: flex;
    height: 100%;
  }

  .pointer {
    cursor: pointer;
  }

  &.table-edit {
    th {
      padding: 10px 15px;
      font-weight: 600;
    }
  }
`;

export const TableTotal = styled.table<ItemProps>`
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 40px;
  width: 100%;
  min-width: ${props => props.minWidth && `${props.minWidth}`};
  thead {
    tr {
      th.head-m {
        font-size: 20px;
        font-weight: 600;
      }
      th.transparent {
        background: transparent;
      }
      th.header-centered {
        text-align: center;
      }
      th.left-radio {
        border-top-left-radius: 8px !important;
      }

      th {
        background-color: #ebedf2;
        border-right: 1px solid #e8e9ed;
        color: var(--DarkGray);
        font-size: 17px;
        font-weight: 600;
        line-height: 25px;
        text-align: center;
        padding: 16px 15px;
        white-space: nowrap;
        &:first-child {
          border-radius: 8px 0 0 0;
        }
        &:last-child {
          color: #fff;
          background-color: rgba(97, 113, 132, 1);
          border-radius: 0 8px 0 0;
          border-right: 0;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }
  tbody {
    tr {
      td.head-lite {
        color: #5d6e81;
        font-size: 15px;
        font-weight: 400;
      }
      td {
        background-color: #fff;
        border-bottom: 1px solid #e8e9ed;
        border-right: 1px solid #e8e9ed;
        color: var(--DarkGray);
        height: 58px;
        font-size: 14px;
        padding: 0 15px;
        text-align: center;
        vertical-align: middle;
        &:first-child {
          border-left: 1px solid #e8e9ed;
          padding: 0px 10px 0px 15px;
        }
        &:last-child {
          font-weight: 600;
        }
      }
    }
  }
`;

export const TableEditDelete = styled.table`
  border-collapse: collapse;
  margin-bottom: 40px;
  width: 100%;
  thead {
    tr {
      th.head-m {
        font-size: 20px;
        font-weight: 600;
      }
      th {
        background-color: #ebedf2;
        border-right: 1px solid #e8e9ed;
        color: var(--DarkGray);
        font-size: 12px;
        font-weight: 500;
        line-height: 25px;
        text-align: left;
        padding: 8px 15px;
        white-space: nowrap;

        &:first-child {
          border-radius: 8px 0 0 0;
        }
        &:last-child {
          border-radius: 0 8px 0 0;
          border-right: 0;
        }
      }
      &:first-child {
        th {
          background-color: #e8e9ed;
          border-radius: 8px 8px 0 0;
          border-right: 0;
        }
      }
      &:last-child {
        background-color: #e8e9ed;
        border-radius: 0px 0px 0 0;
        border-right: 0;
        th {
          background-color: #e8e9ed;
          border-radius: 0px 0px 0 0;
          border-right: 0;
          &:first-child {
            border-radius: 8px 0 0 0;
          }
          &:last-child {
            border-radius: 0 8px 0 0;
            border-right: 0;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td.head-lite {
        color: #5d6e81;
        font-size: 15px;
        font-weight: 400;
      }
      td {
        background-color: #fff;
        border-bottom: 1px solid #e8e9ed;
        border-right: 1px solid #e8e9ed;
        color: var(--DarkGray);
        height: 58px;
        font-size: 14px;
        font-weight: 500;
        padding: 0 15px;
        text-align: left;
        width: min-content;
        vertical-align: middle;
        &:first-child {
          border-left: 1px solid #e8e9ed;
          padding: 0px 10px 0px 15px;
        }
        &:nth-last-child(-n + 2) {
          text-align: center;
        }
      }
      &.tr-average {
        td {
          background-color: #f2f8ff;
          &:first-child {
            background-color: #e6f1ff;
            padding: 0;
          }
        }
      }
      &.special-edit-active {
        td {
          background-color: #f2f8ff !important;
        }
      }
    }
  }
`;
export const TableUnsendInvitations = styled.table`
  border-collapse: collapse;
  margin-bottom: 40px;
  width: 100%;
  thead {
    tr {
      th.head-m {
        font-size: 20px;
        font-weight: 600;
      }
      th {
        background-color: #ebedf2;
        color: var(--DarkGray);
        font-size: 12px;
        font-weight: 500;
        line-height: 25px;
        text-align: left;
        padding: 8px 15px;
        &:first-child {
          border-radius: 8px 0 0 0;
        }
        &:last-child {
          border-radius: 0 8px 0 0;
        }
      }
    }
  }
  tbody {
    tr {
      td.head-lite {
        color: #5d6e81;
        font-size: 15px;
        font-weight: 400;
      }
      td {
        background-color: #fff;
        border-bottom: 1px solid #e8e9ed;
        color: var(--DarkGray);
        height: 58px;
        font-size: 14px;
        font-weight: 500;
        padding: 0 15px;
        text-align: left;
        vertical-align: middle;
        &:first-child {
          padding: 0px 10px 0px 15px;
        }
        &:last-child {
          background-color: var(--BackgroundLighter);
          border-right: 0;
        }
      }
      &.tr-average {
        td {
          background-color: #f2f8ff;
          &:first-child {
            background-color: #e6f1ff;
            padding: 0;
          }
        }
      }
      &.special-edit-active {
        td {
          background-color: #f2f8ff !important;
        }
      }
    }
  }
`;

export const TagWrapper = styled.div`
  justify-content: left;
  flex-wrap: nowrap;
  max-width: 185px;
  margin: 0 auto;
  display: flex;

  & > span {
    margin: 3px;

    padding: 2px 6px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const TagWrapperRounder = styled.div`
  display: flex;
  flex-wrap: nowrap;
  padding: 0;
  & > span {
    margin-top: 3px;
    margin-bottom: 3px;
    margin-right: 5px;
    padding: 2px 6px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const TableAverage = styled.div`
  color: var(--PrimaryBlue);
  font-weight: 500;
  height: 44px;
  line-height: 44px;
  font-size: 12px;
  display: flex !important;
  padding-left: 10px !important;
  flex-direction: row;
  align-items: center;
  min-width: 150px;
`;

export const LoadSpace = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px:
  min-height: 20px;
  max-width: 20px:
  max-height: 20px;
  margin-right: 20px;
  display:flex !important;
  align-items:center;
  justify-content: center;
`;

export const MediaBadge = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const MediaBadgeText = styled.div`
  margin-left: 14px;
  vertical-align: middle;
`;
export const TableContainer = styled.div`
  padding: 25px 42px 0px 42px;
  overflow-x: hidden;
`;
export const TableFailedFooter = styled.div`
  border-top: 1px solid #e8e9ed;
`;
export const TableRequestColumn = styled.td<ItemProps>`
  ${props => {
    const background =
      props.theme === 'strong' ? 'background:rgba(235,237,242,0.38)!important;' : 'background:rgba(235,237,242,0.18)!important;';

    return css`
       {
        ${background}
      }
    `;
  }};
`;
export const RequestColumn = styled.td<ItemProps>`
  min-width: 570px !important;
  ${props => {
    const background =
      props.theme === 'strong' ? 'background:rgba(235,237,242,0.38)!important;' : 'background:rgba(235,237,242,0.18)!important;';
    const textAlign = 'text-align: center!important;';

    return css`
       {
        ${background}
        ${textAlign}
      }
    `;
  }};
`;
export const ButtonWrapper = styled.div`
  display: inline-block;
  margin: 5px 0px 5px 0px;
`;
export const ColumnTitle = styled.p`
  margin: 0px 0px 0px 0px;
`;
export const ColumnSubtitle = styled.p`
  margin: 5px 0px 0px 0px;
  color: rgba(93, 110, 129, 1);
  font-size: 11px;
  font-weight: 300;
`;

export const PlayersTable = styled.table`
  min-width: 80vw;
  border-collapse: collapse;
  thead {
    tr {
      th {
        background-color: rgba(93, 110, 129, 0.15);
        color: rgba(93, 110, 129, 1);
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.66px;

        text-align: left;
        border-right: 1px solid rgba(172, 177, 192, 0.27);
        padding: 10px 5px 5px 5px;

        div {
          width: max-content;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }
      th:last-child {
        border-radius: 0px 8px 0px 0px;
        border-right: 0;
      }
    }
    tr:first-child {
      th {
        background-color: rgba(93, 110, 129, 0.15);
        color: rgba(93, 110, 129, 1);
        font-size: 12px;
        font-weight: 600;
        letter-spacing: -0.07px;
        line-height: 14px;
        text-align: center;
        border-bottom: 1px solid #fff;
        border-right: 0;

        border-radius: 8px 8px 0 0;
      }
    }
  }
`;
export const TableColumnWrapper = styled.div`
  padding: 2.5px 2.5px 2.5px 5px;
  min-width: -webkit-fill-available;
  display: inline-flex;
  align-items: center;

  strong.warning {
    font-size: 14px;
    font-weight: 500;
    color: #f54b23;
  }
`;
export const DynamicRow = styled.tr<ItemProps>`
  position: relative;
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 14px;
  font-weight: 450;
  letter-spacing: 0;
  line-height: 23.68px;

  ${props => props.first && `border-top: 1px solid rgba(172, 177, 192, 0.27);`}

  td {
    border-right: 1px solid rgba(172, 177, 192, 0.27);
    border-bottom: 1px solid rgba(172, 177, 192, 0.27);
  }
  td:first-child {
    border-left: 1px solid rgba(172, 177, 192, 0.27);
  }
  td:nth-child(5) div {
    padding-right: 7px;
  }
  ${props => {
    const weight = props.checked && 'font-weight:600!important;';

    return css`
       {
        ${weight}
      }
    `;
  }};
  td:nth-child(-n + 3) {
    ${props => {
    const background = props.checked ? 'background:rgba(0,122,255,0.05);' : 'background:rgba(247,248,250,1)!important;';

    return css`
         {
          ${background}
        }
      `;
  }};
  }
`;

export const DynamicRowOnboarding = styled.tr<ItemProps>`
  position: relative;
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 14px;
  font-weight: 450;
  letter-spacing: 0;
  line-height: 23.68px;

  ${props => props.first && `border-top: 1px solid rgba(172, 177, 192, 0.27);`}

  td {
    border-right: 1px solid rgba(172, 177, 192, 0.27);
    border-bottom: 1px solid rgba(172, 177, 192, 0.27);
  }
  td:first-child {
    border-left: 1px solid rgba(172, 177, 192, 0.27);
  }
  td:nth-child(5) div {
    padding-right: 7px;
  }
  ${props => {
    const weight = props.checked && 'font-weight:600!important;';

    return css`
       {
        ${weight}
      }
    `;
  }};
  td:nth-child(-n + 14) {
    ${props => {
    const background = props.checked ? 'background:rgba(0,122,255,0.05);' : 'background:rgba(247,248,250,1)!important;';

    return css`
         {
          ${background}
        }
      `;
  }};
  }
`;
export const CheckBoxWrapper = styled.div`
  margin-bottom: 7px;
  display: flex;
  padding: 0px 25px 0px 15px;
  align-items: center;
`;
export const PopUpText = styled.span`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 16px;
  font-weight: 400 !important;
  letter-spacing: 0;
  line-height: 12px;
`;

export const AlertTextWrapper = styled.div<ItemProps>`
  display: inline-flex;
  margin-right: 5px;
  margin-left: 3px;
  font-weight: 400;
  color: ${props => props.alertTextColor ? props.alertTextColor : '#f54b23'};
`;

export const AlertIconWrapper = styled.div<ItemProps>`
  position: relative;
  display: inline-flex;
  color: ${props => props.alertTextColor ? props.alertTextColor : '#f54b23'};
  &:hover div {
    display: flex;
  }
`;
export const TableHealth = styled.table`
  border-collapse: collapse;
  margin-top: 10px;
  width: 100%;
  thead {
    tr {
      th {
        min-width: 50px;
        padding: 0 10px;
        background-color: #ebedf2;
        border-right: 1px solid rgba(172, 177, 192, 0.27);
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.61px;
        line-height: 42px;
        text-align: center;

        &:first-child {
          text-align: left;
          border-radius: 7px 0 0 0;
          padding-left: 18px;
        }
      }
      &:first-child {
        th {
          line-height: 26px;
          background-color: #e8e9ed;
          border-radius: 8px 8px 0 0;
          border-right: 1px solid rgb(247, 248, 250);
          border-bottom: 1px solid rgb(247, 248, 250);
        }
        th:first-child {
          background: transparent;
        }
      }
    }
    tr:last-child {
      th {
        background-color: white;
        line-height: 11px;
        height: 26px;
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 11px;
        letter-spacing: 0.21px;
        font-weight: 400;
        text-align: center;
        border-bottom: 1px solid rgba(172, 177, 192, 0.11);
      }
      th:first-child {
        border-radius: 0px;
        border-left: 1px solid rgba(172, 177, 192, 0.11);
      }
    }
  }
  tbody {
    tr {
      td {
        height: 42px;
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 12px;
        letter-spacing: 0;
        line-height: 12.2px;
        text-align: center;
        background-color: white;
        border: 1px solid rgba(172, 177, 192, 0.11);
      }
    }
  }
`;
export const TableWellness = styled.table<ItemProps>`
  border-collapse: collapse;
  height:fit-content;
  margin-top: 10px;
  width: 100%;
  margin-bottom: 40px;
  min-width: ${props => props.minWidth && `${props.minWidth}`};
  thead {
    tr {
      th {
        box-shadow: inset 0px -1px #e8e9ed;
        min-width: 50px;
        padding: 0 10px;
        background-color: #ebedf2;
        border-right: 1px solid rgba(172, 177, 192, 0.27);
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.61px;
        line-height: 42px;
        text-align: center;
      }
      &:first-child {
        th {
          line-height: 26px;
          background-color: #e8e9ed;
          border-radius: 8px 8px 0 0;
          border-right: 1px solid rgb(247, 248, 250);
          border-bottom: 1px solid rgb(247, 248, 250);
        }
        th:first-child {
          background: var(--BackgroundGrey);
          border-radius: 0px;
          box-shadow: 1px 1px var(--BackgroundGrey);
        }
      }
    }
    tr:first-child {
      th {
        font-size: 9px;
        font-weight: 300;
        line-height: 21px;
      }
    }
    tr:nth-child(2) {
      th:first-child {
        text-align: left;
        border-radius: 7px 0 0 0;
        padding-left: 60px;
      }
    }
    tr:last-child {
      cursor: pointer;
      th {
        background-color: white;
        line-height: 11px;
        height: 26px;
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 11px;
        letter-spacing: 0.21px;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        border-bottom: 1px solid rgba(172, 177, 192, 0.11);
      }
      th:first-child {
        border-radius: 0px;
        border-left: 1px solid rgba(172, 177, 192, 0.11);
      }
    }
  }
  tbody {
    tr {
      background-color: white;
      td {
        height: 42px;
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 12px;
        letter-spacing: 0;
        line-height: 12.2px;
        text-align: center;

        border: 1px solid rgba(172, 177, 192, 0.11);
      }
      td:first-child {
        padding-left: 15px;
      }
    }
    tr:first-child {
      td:first-child {
        padding-left: 0px;
      }
    }
  }
`;

export const TablePlayerWellness = styled.table`
  border-collapse: collapse;
  margin-top: 10px;
  width: 100%;
  margin-bottom: 40px;
  thead {
    tr {
      th {
        box-shadow: inset 0px -1px #e8e9ed;
        min-width: 50px;
        padding: 0 10px;
        background-color: #ebedf2;
        border-right: 1px solid rgba(172, 177, 192, 0.27);
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.61px;
        line-height: 42px;
        text-align: center;
      }
      &:first-child {
        th {
          line-height: 26px;
          background-color: #e8e9ed;
          border-radius: 8px 8px 0 0;
          border-right: 1px solid rgb(247, 248, 250);
          border-bottom: 1px solid rgb(247, 248, 250);
        }
      }
    }
    tr:first-child {
      th {
        font-size: 9px;
        font-weight: 300;
        line-height: 21px;
      }
    }
    tr:last-child {
      th {
        background-color: white;
        white-space: nowrap;
        line-height: 11px;
        height: 26px;
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 11px;
        letter-spacing: 0.21px;
        font-weight: 400;
        text-align: center;
        border-bottom: 1px solid rgba(172, 177, 192, 0.11);
      }
      th:first-child {
        border-radius: 0px;
        border-left: 1px solid rgba(172, 177, 192, 0.11);
      }
      span {
        cursor: pointer;
      }
    }
  }
  tbody {
    tr {
      background-color: white;
      td {
        height: 42px;
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 12px;
        letter-spacing: 0;
        line-height: 12.2px;
        text-align: center;
        background-color: white;
        border: 1px solid rgba(172, 177, 192, 0.11);
      }
    }
  }
`;
export const TableAccountability = styled.table<ItemProps>`
  border-collapse: collapse;
  margin-top: 10px;
  width: 100%;
  min-width: ${props => props.minWidth && `${props.minWidth}`};
  margin-bottom: 40px;
  thead {
    tr {
      th {
        box-shadow: inset 0px -1px #e8e9ed;
        min-width: 50px;
        padding: 0 10px;
        background-color: #ebedf2;
        border-right: 1px solid rgba(172, 177, 192, 0.27);
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.61px;
        line-height: 42px;
        text-align: center;

        &:first-child {
          text-align: left;
          border-radius: 7px 0 0 0;
          padding-left: 18px;
        }
        span {
          cursor: pointer;
        }
      }
      &:first-child {
        th {
          background-color: #e8e9ed;

          border-right: 1px solid rgb(247, 248, 250);
          border-bottom: 1px solid rgb(247, 248, 250);
        }
        th:first-child {
          border-radius: 8px 0 0 0;
          padding-left: 60px;
        }
        th:last-child {
          border-radius: 0 8px 0 0;
          padding-left: 45px;
        }
      }
    }

    tr:last-child {
      th {
        background-color: white;
        line-height: 11px;
        height: 26px;
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 11px;
        letter-spacing: 0.21px;
        font-weight: 400;
        text-align: center;
        border-bottom: 1px solid rgba(172, 177, 192, 0.11);
      }
      th:first-child {
        border-radius: 0px;
        border-left: 1px solid rgba(172, 177, 192, 0.11);
      }
    }
  }
  tbody {
    tr {
      background-color: white;
      td {
        height: 42px;
        color: rgba(93, 110, 129, 1);
        font-family: 'Proxima Nova';
        font-size: 12px;
        letter-spacing: 0;
        line-height: 12.2px;
        text-align: center;
        border: 1px solid rgba(172, 177, 192, 0.11);
      }
      td:first-child {
        padding-left: 15px;
      }
    }
    tr:first-child {
      td:first-child {
        padding-left: 0px;
      }
    }
  }
`;
export const StickyMainHeader = styled.th`
  z-index: 1;
  position: sticky !important;
  top: 160px;
  @media (max-width: 1400px) {
    top: 0px;
    position: sticky !important;
  }
`;
export const StickyShadowMainHeader = styled.th`
  z-index: 1;
  position: sticky !important;
  top: 160px;
  background-color: #e5e7ed !important;
  @media (max-width: 1400px) {
    top: 0px;
    position: sticky !important;
  }
`;
export const DarkStickyMainHeader = styled.th`
  top: 160px;
  position: sticky !important;
  border-top: 1px solid #ebedf2 !important;
  border-bottom: 1px solid #ebedf2 !important;
  @media (max-width: 1400px) {
    top: 0px;
    position: sticky !important;
  }
`;
export const DarkStickyShadowMainHeader = styled.th`
  top: 160px;
  position: sticky !important;
  border-top: 1px solid #e5e7ed !important;
  border-bottom: 1px solid #e5e7ed !important;
  background-color: #e5e7ed !important;
  @media (max-width: 1400px) {
    top: 0px;
    position: sticky !important;
  }
`;
export const StickySubHeader = styled.th`
  z-index: 1;
  position: sticky !important;
  top: 202px;
  @media (max-width: 1400px) {
    top: 0px;
    position: sticky !important;
  }
`;
export const StickyShadowSubHeader = styled.th`
  position: sticky !important;
  top: 202px;
  background-color: #ebedf2 !important;
  @media (max-width: 1400px) {
    top: 0px;
    position: sticky !important;
  }
`;
export const ShadowTableHead = styled.th`
  z-index: 1;
  background: #f7f8fa !important;
  position: sticky !important;
  top: 202px;
  @media (max-width: 1400px) {
    top: 0px;
    position: sticky !important;
  }
`;
export const StickyTableHead = styled.th<ItemProps>`
  position: sticky !important;
  top: ${props => props.topPosition};
  @media (max-width: 1400px) {
    top: ${props => props.topPositionResponsive};
  }
`;

export const StickyTableHeadDate = styled.th<ItemProps>`
  position: sticky !important;
  top: ${props => props.topPosition};
  background: white;
  font-weight: normal;
  height: 24px;
  background-color: white;
  border: 1px solid rgba(171, 176, 191, 0.27);
  position: -webkit-sticky !important;
  z-index: 1;
  opacity: 1;
  cursor: pointer;
  @media (max-width: 1400px) {
    top: ${props => props.topPositionResponsive};
  }
`;
export const StickyTableHeadList = styled.th<ItemProps>`
  z-index: 1;
  position: sticky !important;
  top: ${props => props.topPosition};
`;
export const ArrowHolder = styled.div`
  margin-left: auto;
  align-items: center;
  display: flex;
  width: 12px;
`;
export const ArrowHolderSummary = styled.div`
  align-items: center;
  display: flex;
  width: 12px;
  margin-right: auto;
`;
export const ColumnContainer = styled.div`
  display: flex;
`;
export const ColumnContainerSummary = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(1, auto) 2fr;
  grid-column-gap: 5px;
  justify-items: center;
  white-space: nowrap;
  span {
    grid-column-start: 2;
  }
`;
export const TeamNameWrapper = styled.td`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 150px;
`;
export const LocationWrapper = styled.td<ItemProps>`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  background: ${props => (props.theme === 'light' ? 'white' : '#f7f8fa')} !important;
  padding: 0px 5px;
  max-width: 150px;
`;
export const TeamNamePopUp = styled.div<ItemProps>`
  position: fixed;
  display: inline-block;
  padding: 6px 10px 12px 10px;
  z-index: 1;
  height: min-content;
  width: min-content;
  border-radius: 3.53px;
  background-color: rgba(62, 70, 78, 0.75);
  color: rgba(247, 248, 250, 1);
  font-family: 'Proxima Nova';
  font-size: 14px;
  letter-spacing: 0;
  line-height: 16.91px;
  font-weight: 300;
  ${props => `left:${props.posX}px;top:${props.posY}px;`}
`;
export const ChangeContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
`;
export const ArrowDownContainer = styled.div`
  margin-left: 3px;
  background: rgba(93, 110, 129, 1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
`;

export const TeamAverageRow = styled.tr`
  td {
    background-color: #f2f8ff;
    &:first-child {
      border-left: 7px solid var(--PrimaryBlue) !important;
      color: var(--PrimaryBlue);
      font-weight: bold;
    }
  }
`;
export const DownloadButton = styled.div<ItemProps>`
  font-size: 10px;
  padding: 6px;
  width: 40px;
  height: 12px;
  font-weight: bolder !important;
  color: ${props => (props.type === 'PDF' ? '#F75A68' : '#50B480')};
  background: linear-gradient(180deg, #fcfcfc 0%, #f6f6f6 98.43%);
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  margin-left: 9px;
  cursor: pointer;
  &:nth-child(2) {
    margin-left: 8px;
  }
`;

export const ReportTableColumn = styled.td`
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  padding: 10px;
  height: 23px !important;
`;

export const HideIcon = styled.td`
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px !important;
  height: 100% !important;
`;

interface TableProps {
  readonly fontWeight?: string;
  readonly hide?: boolean;
  readonly bgColor?: string;
  readonly textAlign?: string;
  readonly color?: string;
  readonly border?: string;
  readonly width?: string;
  readonly height?: string;
  readonly alignItems?: string;
  readonly justifyContent?: string;
  readonly minWidth?: string;
  readonly sticky?: number;
  readonly top?: string;
  readonly cursor?: string;
  readonly fontSize?: string;
  readonly mBottom?: string;
}

export const TableUnit = styled.table<TableProps>`
  max-width: 100%;
  overflow-x: scroll;
  width: calc(100% - 2px);
  margin-bottom: ${props => (props.mBottom ? props.mBottom : '0')};
  color: ${props => (props.color ? props.color + ' !important' : '#5D6E81 !important')};
  font-size: ${props => (props.fontSize ? props.fontSize + ' !important' : '11px !important')};
  border-collapse: collapse;
  ${props => `
  min-width:${props.minWidth};
  `}
  height:fit-content;
`;

export const TableHead = styled.thead``;

export const TableTopHeader = styled.th<TableProps>`
  font-weight: bold;
  background-color: rgba(94, 111, 130, 0.15);
  border-radius: 6px 6px 0 0;
  height: 28px;
  position: -webkit-sticky;
  position: sticky !important;
  top: 0px;
  opacity: ${props => (props.hide ? '0' : '1')};
  ${props => (props.hide ? 'color:' + props.color : '')}
`;

export const TableHeader = styled.th<TableProps>`
  background-color: #ebedf2;
  height: 42px;
  font-weight: ${props => (props.fontWeight ? props.fontWeight : 'bold')};
  padding: 0px 20px;
  border-left: 1px solid rgba(171, 176, 191, 0.27);
  position: sticky !important;
  z-index: 1;
  top: 0;
  &:first-child {
    border-radius: 8px 0 0 0;
    border: none;
  }
`;

export const TableTopHeaderSub = styled.span`
  font-weight: normal;
`;

export const TableSubHeader = styled.th<TableProps>`
  font-weight: normal;
  height: 24px;
  border: ${props => (props.border ? props.border : '1px solid rgba(171, 176, 191, 0.27)')};
  position: sticky !important;
  z-index: 1;
  top: 0;
  opacity: ${props => (props.hide ? '0' : '1')};
  cursor: ${props => (props.cursor ? props.cursor : 'auto')};
  background: ${props => (props.bgColor ? props.bgColor : 'white')} !important;
`;

export const WrapperSortingTableHead = styled.th<TableProps>`
  height: 28px;

  position: sticky !important;
  top: 202px;
  @media (max-width: 1400px) {
    top: 0px;
    position: sticky !important;
  }

  background: ${props => (props.bgColor ? props.bgColor : 'white')} !important;
`;

export const SortingTableHeader = styled.th<TableProps>`
  height: 28px;
  background: ${props => (props.bgColor ? props.bgColor : 'white')} !important;
`;

export const TableBody = styled.tbody`
  font-weight: normal;
`;

export const TableRow = styled.tr<TableProps>`
  ${props => 'height:' + props.height};
  ${props => {
    let color;
    switch (props.bgColor) {
      case 'watch':
        color = '#FFF6D1';
        break;
      case 'warning':
        color = '#FDF5FF';
        break;
      case 'medical':
        color = '#E8FFFF';
        break;
      case 'normal':
        color = '#F7F8FA';
        break;
      default:
        color = props.bgColor;
        break;
    }
    const background = 'background:' + color + ';';
    return css`
       {
        ${background}
      }
    `;
  }};
`;

export const TableColumn = styled.td<TableProps>`
  height: ${props => (props.height ? props.height : '44px')};
  padding: 0px 6px;
  text-align: ${props => (props.textAlign ? props.textAlign : 'center')};
  border: ${props => (props.border ? props.border : '1px solid rgba(171, 176, 191, 0.27)')};
  ${props => `
  background-color:${props.bgColor};
  width:${props.width};
  `}
`;

export const PlayerColumn = styled(TableColumn)``;

export const TableColumnBold = styled(TableColumn)`
  font-weight: bold;
  padding: 0px 6px 0px 20px;
`;

interface InputErasableProps {
  readonly mWidth?: string;
  readonly height?: string;
  readonly backgroundColor?: string;
  readonly right?: string;
  readonly border?: string;
  readonly cursor?: string;
  readonly width?: string;
}

export const InputErasableContainer = styled.div<InputErasableProps>`
  border: 1px solid #e5e7ed;
  width: ${props => props.width};
  min-width: ${props => props.mWidth};
  height: 28px;
  background-color: ${props => props.backgroundColor};
  color: #bac1c9;
  border-radius: 6px;
  font-size: 11px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:focus-within {
    border: 1px solid #007aff;
  }
`;

export const InputErasableField = styled.input<InputErasableProps>`
  width: 100%;
  outline: none;
  text-align: center;
  border: none;
  font-size: 11px;
  color: #5d6e81;
`;

export const InputErasableDelete = styled.div<InputErasableProps>`
  position: absolute;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
  right: ${props => (props.right ? props.right : '10px')};
  border: ${props => (props.border ? props.border : '1px solid #B5B7BD')};
  cursor: ${props => (props.cursor ? props.cursor : 'pointer')};
  color: #c5c7cd;
  min-height: 14px;
  border-radius: 50%;
  min-width: 14px;
  text-align: center;
`;

export const SortArrow = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const Placeholder = styled.span`
  display: flex;
  flex-direction: column;
  color: #7f8b99;
  font-family: 'Baloo Thambi 2';
  font-size: 19px;
  letter-spacing: 0.47px;
  line-height: 30px;
  text-align: center;
  position: relative;
  top: 11rem;
  opacity: 0.6;
`;

export const BoldSpan = styled.span`
  font-family: 'Proxima Nova';
  font-weight: 600;
`;

export const FeatureLocked = styled.div<FeatureLocked>`
  top: 11px;
  height: 23px;
  display: flex;
  opacity: 0.98;
  position: absolute;
  align-items: center;
  border-radius: 59px;
  background: #EBECF2;
  justify-content: center;
  left: ${props => props.left}px;
  right: ${props => props.right}px;
`;

export const TitleFeatureLocked = styled.span`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #607184;
`

export const TextFeatureLocked = styled.span`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #607184;
`
export const Tooltip = styled.div`
  top: -17px;
  left: 30px;
  z-index: 1;
  height: 52px;
  display: none;
  padding: 0 10px;
  width: max-content;
  position: absolute;
  border-radius: 4px;
  align-items: center;
  background: #FFFFFF;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #BEC6D0;

  span {
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #000000;
  }

  &:after,
  &:before {
    content: '';
    width: 0;
    height: 0;
    left: 100%;
    display: block;
    position: absolute;
    border-style: solid;
  }

  &:before {
    left: -18px;
    border-width: 9px;
    top: calc(50% - 18px/2);
    border-color: transparent #BEC6D0 transparent transparent;
  }

  &:after {
    left: 0;
    left: -16.5px;
    border-width: 9px;
    top: calc(50% - 18px/2);
    border-color: transparent #FFF transparent transparent;
  }
`;
